
import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import MuffinLoader from "@/components/Muffin/Loader.vue";
import { defineComponent } from 'vue';
import PrzBlock from './Block/Desktop.vue';
//import PrzBanners from './Block/BannersDesktop.vue';
import Common from './Common.vue';

Vue.use(VueObserveVisibility);

export default defineComponent({
    components: {
        PrzBlock,
        MuffinLoader,
        //PrzBanners
        PrzBanners: () => import('./Block/BannersDesktop.vue'),
        PrzMention: () => import('./Singles/Social/MentionModal.vue'),
    },
    extends: Common,
    computed:{
        margin(){
            return Math.max(document.documentElement.clientHeight || 100, window.innerHeight || 100) * 1.3;
        },
        gridSelected(): number{
            return this.visualViewportWidth >= 1920 ? 16 : 12;
        }
    },
});
